import type { Plan } from "../../../redux/api";

export const todayISO = () => new Date().toISOString().slice(0, 10);

// End date implied by the billing cycle from a given start date.
export const addCycle = (startDate: string, billingCycle: string): string => {
  const d = new Date(startDate);
  if (Number.isNaN(d.getTime())) return startDate;
  switch (billingCycle) {
    case "monthly":
      d.setMonth(d.getMonth() + 1);
      break;
    case "quarterly":
      d.setMonth(d.getMonth() + 3);
      break;
    case "half-yearly":
      d.setMonth(d.getMonth() + 6);
      break;
    case "yearly":
      d.setFullYear(d.getFullYear() + 1);
      break;
    default:
      return startDate; // custom — leave to manual entry
  }
  return d.toISOString().slice(0, 10);
};

// The plan's own standard price for a given billing cycle/currency — used to
// pre-fill "Amount paid" and to flag when a subscription's amount has been
// negotiated away from the list price. "custom" cycles have no standard price
// (there's nothing to compare against), so this returns undefined for those.
export const standardPriceFor = (
  plan: Plan | undefined,
  billingCycle: string,
  currency: string,
): number | undefined => {
  if (!plan) return undefined;
  const useUsd = currency === "USD";
  const monthly = (useUsd ? plan.usdMonthlyPrice : undefined) ?? plan.monthlyPrice;
  const yearly = (useUsd ? plan.usdYearlyPrice : undefined) ?? plan.yearlyPrice;
  switch (billingCycle) {
    case "monthly":
      return monthly;
    case "quarterly":
      return monthly * 3;
    case "half-yearly":
      return monthly * 6;
    case "yearly":
      return yearly;
    default:
      return undefined;
  }
};

export const SOURCE_LABEL: Record<string, string> = {
  manual: "Manual",
  self_serve: "Self-serve signup",
  subscription_upgrade_request: "Upgrade request approved",
};
